import { buildCssClassName } from "@/3514/utils"

const _sharedTabClasses: string = buildCssClassName(
    "pt-[15px]",
    "md:pt-[40px]",
    "px-[15px]",
    "md:px-[30px]",
    "lg:px-[80px]",
    "pb-[100px]",
    "self-center",
    "w-full"
)

export default {
    page: {
        error: (): string => "mx-auto !mt-[5%]"
    },
    diagnosticTab: {
        container: (): string =>
            buildCssClassName(_sharedTabClasses, "md:max-w-[calc(800px+60px)] lg:max-w-[calc(800px+160px)]"),
        emptyHint: (): string => "mt-0 mb-auto py-[10px] px-[15px] bg-blue-600 rounded-[5px] w-full"
    },
    sessionsTab: {
        container: (): string =>
            buildCssClassName(
                _sharedTabClasses,
                "max-[767px]:mt-[10px]",
                "md:max-w-[calc(800px+60px)] lg:max-w-[calc(800px+160px)]"
            )
    },
    planTab: {
        container: (): string =>
            buildCssClassName(_sharedTabClasses, "md:max-w-[calc(800px+60px)] lg:max-w-[calc(940px+160px)]"),
        emptyHint: (): string => "mt-0 mb-auto py-[10px] px-[15px] bg-blue-600 rounded-[5px] w-full"
    }
}
